import { useQuery } from 'react-query';
import * as React from 'react';
import { gamesUrls } from 'utils/apiUrls';
import { fetchGamesTracking } from 'pages/Dashboard/services/tracking.services';
import { StroopTimeSeriesAPIResponse } from 'pages/Dashboard/types/waypoints.types';
import { useHttp } from 'hooks/use-fetch';

interface UseStroopDataProps {
  providerId: string | undefined;
  patientId: string | undefined;
  timeFrame: string;
}
function useStroopData({ providerId, patientId, timeFrame }: UseStroopDataProps) {
  const { http } = useHttp();
  const stroopQuery = useQuery(
    [
      `${gamesUrls.stroopTimeSeries.queryUrl}`,
      providerId,
      patientId,
      timeFrame,
    ],
    {
      queryFn: fetchGamesTracking(
        http.get as (url: string, params?: unknown) => Promise<unknown>,
      ),
      enabled: !!providerId && !!patientId,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  );

  const stroopTimeSeriesData = React.useMemo(
    () => (stroopQuery.data as StroopTimeSeriesAPIResponse)?.data || [],
    [stroopQuery.data],
  );

  const stroopTimeSeriesAvgData = React.useMemo(
    () => (stroopQuery.data as StroopTimeSeriesAPIResponse)?.absoluteAvgValue || 0,
    [stroopQuery.data],
  );

  const isStroopTimeSeriesDataLoading = stroopQuery.isFetching;

  return {
    stroopTimeSeriesData,
    stroopTimeSeriesAvgData,
    isStroopTimeSeriesDataLoading,
  };
}

export default useStroopData;
